// extracted by mini-css-extract-plugin
module.exports = {"clientInfo":"brand_clientInfo__3RWUa","clientLogo":"brand_clientLogo__1sSA7","clientName":"brand_clientName__ncy5R"};